import apiClient from '../../../api/client';
import { API_PATHS } from '../../../api/paths';
import { telegram } from '../../../utils/telegram';
import type { ApiResponse } from '../../../types/api';
import type { HomeResponse } from '../model/types';

/**
 * GET /api/v1/client/home — aggregate endpoint.
 * Auth: Authorization: tma <initData> (per-request override).
 */
export const homeApi = {
  getHome: async (signal?: AbortSignal): Promise<HomeResponse> => {
    const initData = telegram.getInitData();
    const res = await apiClient.get<ApiResponse<HomeResponse>>(API_PATHS.CLIENT_HOME, {
      signal,
      headers: {
        Authorization: `tma ${initData}`,
      },
    });
    const data = res.data.data;
    if (data === undefined || data === null) {
      throw new Error("Server bo'sh javob qaytardi");
    }
    return data;
  },
};
